import React from "react";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Typography,
  Grid,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UploadDocument from "@assets/images/uploadImage.svg";
import { ImagePreviewGridRow } from "./ImagePreviewGridRow";
import { setActiveStep } from "@modules/stepper/redux/stepperSlice";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "@store/store";
import { useDispatch } from "react-redux";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";

const imageUrls = [
  UploadDocument,
  UploadDocument,
  UploadDocument,
  UploadDocument,
];

export const MediaUpload: React.FC<{
  isExpanded: boolean;
  toggleExpand: () => void;
  visible?: boolean;
}> = ({ isExpanded, toggleExpand, visible }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  return (
    <Box>
      <Card sx={{ boxShadow: "none", border: "1px solid #E7E8E9" }}>
        <Box
          sx={{
            backgroundColor: "#F4F2F7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pl: 2,
            borderBottom: "1px solid #E7E8E9",
            py: "5px",
          }}
        >
          <Typography
            className="preview-dropdown-header"
            sx={{ fontSize: 12 }}
            fontWeight="semi-bold"
          >
            Uploaded Plot Pictures
            {visible && (
              <IconButton
                className="ml-4"
                onClick={() => {
                  dispatch(setActiveStep(2));
                  navigate("/stepper-row#upload-plot-pictures");
                }}
              >
                <ModeEditOutlineOutlinedIcon />
              </IconButton>
            )}
          </Typography>
          <IconButton aria-label="Collapse section" onClick={toggleExpand}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>
        {isExpanded && (
          <Box sx={{ pt: 2, px: 2 }}>
            <ImagePreviewGridRow visibleIcons={false} />
          </Box>
        )}
      </Card>
    </Box>
  );
};
